import { state, props } from 'cerebral/tags'
import { set, when } from 'cerebral/operators'
import loadMediaFiles from 'modules/Media/chains/loadMediaFiles'
import createSnackbar from 'modules/App/factories/createSnackbar'
import isUserAdmin from 'modules/App/actions/isUserAdmin'

export default [
  set(props`user`, state`app.user`),
  when(state`node.listType`, view => view === 'FOLDER'),
  {
    true: [
      set(state`node.listType`, 'HIERARCHICALLY'),
      ...loadMediaFiles,
      isUserAdmin,
      {
        true: [createSnackbar({ key: 'bms.media.hierarchicalView' })],
        false: [createSnackbar({ key: 'bms.media.hierarchicalView.user' })]
      }
    ],
    false: [
      set(state`node.listType`, 'FOLDER'),
      ...loadMediaFiles,
      createSnackbar({ key: 'bms.media.normalView' })
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/setListType.js